import { createContext } from 'react';

const DataviewerState = createContext();

export default DataviewerState;
